import React, { useState } from 'react'
import { Col, Image, Modal, Row } from 'react-bootstrap'
import { brandImage4, brandImage7, enlargeIcon, goldLifetimeImage, logoBlack } from '../../assets'

export default function Section2() {
  const [ShowImageEnlargeModal, setShowImageEnlargeModal] = useState(false)
  return (
    <Row className='section5 mx-0'>
      <Modal show={ShowImageEnlargeModal} onHide={() => setShowImageEnlargeModal(false)}>
        <Image src={goldLifetimeImage} width='100%' />
      </Modal>
      <Col lg={6} className='d-flex flex-column justify-content-center align-items-center'>
        <div style={{ cursor: 'pointer' }} onClick={() => setShowImageEnlargeModal(true)}>
          <Image src={goldLifetimeImage} width='256px' height='205px' style={{boxShadow:'0px 25px 45px #000000'}} />
          <div className='d-flex align-items-center w-100 justify-content-center mb-3 mt-3'>
            <Image src={enlargeIcon} width='21px' height='21px' />
            <p className='mb-0' style={{ color: 'white', fontWeight: '700' }}>CLICK TO ENLARGE</p>
          </div>
        </div>
        <Image src={brandImage7} className='brand-image2' width={'433px'} height='433px'/>

      </Col>
      <Col lg={6} className='d-flex flex-column justify-content-center align-items-center'>
        <Image src={logoBlack} width='382px' height='auto' />
        <p align='left' style={{fontWeight:'500'}}>Fire resistant plywood are made from high density hardwood
          veneers that are treated with fire resistant chemicals.
          <br /><br />
          They are designed to resist extreme fire conditions, sparks
          and lower the pace of fire generation in case of a fire.
          Fire resistant plywood are advisable to be used in kitchen,
          cooking areas, cinema halls, shopping malls, restaurant,
          train, bus coaches, ships etc to avoid any kind of accidental
          fire, electrical fire.</p>
        <Image src={brandImage4} className='brand-image2' style={{marginTop:'62px'}} />
      </Col>
    </Row>
  )
}
